import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";import BannerImg from "../assets/Images/hkasharmony.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import Img1 from "../assets/ceremonyPics/0.webp";
import Img2 from "../assets/ceremonyPics/2.webp";
import Img3 from "../assets/ceremonyPics/3.webp";
import Img4 from "../assets/ceremonyPics/4.webp";
import Img5 from "../assets/ceremonyPics/5.webp";
import Img6 from "../assets/ceremonyPics/6.webp";
import Img7 from "../assets/ceremonyPics/7.webp";
import Img8 from "../assets/ceremonyPics/8.webp";
import Img9 from "../assets/ceremonyPics/9.webp";
import Img10 from "../assets/ceremonyPics/10.webp";
import Img11 from "../assets/ceremonyPics/11.webp";
import Img12 from "../assets/ceremonyPics/12.webp";
import Img13 from "../assets/ceremonyPics/13.webp";
import Img14 from "../assets/ceremonyPics/14.webp";
import Img15 from "../assets/ceremonyPics/15.webp";
import Img16 from "../assets/ceremonyPics/16.webp";
import Img17 from "../assets/ceremonyPics/17.webp";
import Img18 from "../assets/ceremonyPics/18.webp";
import Img19 from "../assets/ceremonyPics/19.webp";
import Img20 from "../assets/ceremonyPics/20.webp";
import Img21 from "../assets/ceremonyPics/21.webp";
import Img22 from "../assets/ceremonyPics/22.webp";
import Img23 from "../assets/ceremonyPics/23.webp";
import Img24 from "../assets/ceremonyPics/24.webp";
import Img25 from "../assets/ceremonyPics/25.webp";
import Img26 from "../assets/ceremonyPics/26.webp";
import Img27 from "../assets/ceremonyPics/27.webp";
import Img28 from "../assets/ceremonyPics/28.webp";
import Img29 from "../assets/ceremonyPics/29.webp";
import Img30 from "../assets/ceremonyPics/30.webp";
import Img31 from "../assets/ceremonyPics/31.webp";
import Img32 from "../assets/ceremonyPics/32.webp";
import Img33 from "../assets/ceremonyPics/33.webp";
import Img34 from "../assets/ceremonyPics/34.webp";
import Img35 from "../assets/ceremonyPics/35.webp";
import Img36 from "../assets/ceremonyPics/36.webp";
import Img37 from "../assets/ceremonyPics/37.webp";
import Img38 from "../assets/ceremonyPics/38.webp";
import Img39 from "../assets/ceremonyPics/39.webp";
import Img40 from "../assets/ceremonyPics/40.webp";
import Img41 from "../assets/ceremonyPics/41.webp";
import Img42 from "../assets/ceremonyPics/42.webp";
import Img43 from "../assets/ceremonyPics/43.webp";
import Img44 from "../assets/ceremonyPics/44.webp";
import Img45 from "../assets/ceremonyPics/45.webp";
import Img46 from "../assets/ceremonyPics/46.webp";
import Img47 from "../assets/ceremonyPics/47.webp";
import Img48 from "../assets/ceremonyPics/48.webp";
import Img49 from "../assets/ceremonyPics/49.webp";
import Img50 from "../assets/ceremonyPics/50.webp";
import Img51 from "../assets/ceremonyPics/51.webp";
import Img52 from "../assets/ceremonyPics/52.webp";
import Img53 from "../assets/ceremonyPics/53.webp";
import Img54 from "../assets/ceremonyPics/54.webp";
import Img55 from "../assets/ceremonyPics/55.webp";
import Img56 from "../assets/ceremonyPics/56.webp";
import Img57 from "../assets/ceremonyPics/57.webp";
import Img58 from "../assets/ceremonyPics/58.webp";
import Img59 from "../assets/ceremonyPics/59.webp";
import Img60 from "../assets/ceremonyPics/60.webp";
import Img61 from "../assets/ceremonyPics/61.webp";
import Img62 from "../assets/ceremonyPics/62.webp";
import Img63 from "../assets/ceremonyPics/63.webp";
import Img64 from "../assets/ceremonyPics/64.webp";
import Img65 from "../assets/ceremonyPics/65.webp";
import Img66 from "../assets/ceremonyPics/66.webp";
import Img67 from "../assets/ceremonyPics/67.webp";
import Img68 from "../assets/ceremonyPics/68.webp";
import Img69 from "../assets/ceremonyPics/69.webp";
import Img70 from "../assets/ceremonyPics/70.webp";
import Img71 from "../assets/ceremonyPics/71.webp";
import Img72 from "../assets/ceremonyPics/72.webp";
import Img73 from "../assets/ceremonyPics/73.webp";
import Img74 from "../assets/ceremonyPics/74.webp";
import Img75 from "../assets/ceremonyPics/75.webp";
import Img76 from "../assets/ceremonyPics/76.webp";
import Img77 from "../assets/ceremonyPics/77.webp";
import Img78 from "../assets/ceremonyPics/78.webp";
import Img79 from "../assets/ceremonyPics/79.webp";
import Img80 from "../assets/ceremonyPics/80.webp";
import Img81 from "../assets/ceremonyPics/81.webp";
import Img82 from "../assets/ceremonyPics/82.webp";
import Img83 from "../assets/ceremonyPics/83.webp";
import Img84 from "../assets/ceremonyPics/84.webp";
import Img85 from "../assets/ceremonyPics/85.webp";
import Img86 from "../assets/ceremonyPics/86.webp";
import Img87 from "../assets/ceremonyPics/87.webp";
import Img88 from "../assets/ceremonyPics/88.webp";
import Img89 from "../assets/ceremonyPics/89.webp";
import Img90 from "../assets/ceremonyPics/90.webp";
import Img91 from "../assets/ceremonyPics/91.webp";
import Img92 from "../assets/ceremonyPics/92.webp";
import Img93 from "../assets/ceremonyPics/93.webp";
import Img94 from "../assets/ceremonyPics/94.webp";
import Img95 from "../assets/ceremonyPics/95.webp";
import Img96 from "../assets/ceremonyPics/96.webp";
import Img97 from "../assets/ceremonyPics/97.webp";
import Img98 from "../assets/ceremonyPics/98.webp";
import Img99 from "../assets/ceremonyPics/99.webp";
import Img100 from "../assets/ceremonyPics/100.webp";
import Img101 from "../assets/ceremonyPics/101.webp";
import Img102 from "../assets/ceremonyPics/102.webp";
import Img103 from "../assets/ceremonyPics/103.webp";
import Img104 from "../assets/ceremonyPics/104.webp";
import Img105 from "../assets/ceremonyPics/105.webp";
import Img106 from "../assets/ceremonyPics/106.webp";
import Img107 from "../assets/ceremonyPics/107.webp";
import Img108 from "../assets/ceremonyPics/108.webp";
import Img109 from "../assets/ceremonyPics/109.webp";
import Img110 from "../assets/ceremonyPics/110.webp";
import Img111 from "../assets/ceremonyPics/111.webp";
import Img112 from "../assets/ceremonyPics/112.webp";
import Img113 from "../assets/ceremonyPics/113.webp";
import Img114 from "../assets/ceremonyPics/114.webp";
import Img115 from "../assets/ceremonyPics/115.webp";
import Img116 from "../assets/ceremonyPics/116.webp";
import Img117 from "../assets/ceremonyPics/117.webp";
import Img118 from "../assets/ceremonyPics/118.webp";
import Img119 from "../assets/ceremonyPics/119.webp";
import Img120 from "../assets/ceremonyPics/120.webp";
import Img121 from "../assets/ceremonyPics/121.webp";
import Img122 from "../assets/ceremonyPics/122.webp";
import Img123 from "../assets/ceremonyPics/123.webp";
import Img124 from "../assets/ceremonyPics/124.webp";
import Img125 from "../assets/ceremonyPics/125.webp";
import Img126 from "../assets/ceremonyPics/126.webp";
import Img127 from "../assets/ceremonyPics/127.webp";
import Img128 from "../assets/ceremonyPics/128.webp";
import Img129 from "../assets/ceremonyPics/129.webp";
import Img130 from "../assets/ceremonyPics/130.webp";
import Img131 from "../assets/ceremonyPics/131.webp";
import Img132 from "../assets/ceremonyPics/132.webp";
import Img133 from "../assets/ceremonyPics/133.webp";
import Img134 from "../assets/ceremonyPics/134.webp";
import Img135 from "../assets/ceremonyPics/135.webp";
import Img136 from "../assets/ceremonyPics/136.webp";
import Img137 from "../assets/ceremonyPics/137.webp";
import Img138 from "../assets/ceremonyPics/138.webp";
import Img139 from "../assets/ceremonyPics/139.webp";
import Img140 from "../assets/ceremonyPics/140.webp";
import Img141 from "../assets/ceremonyPics/141.webp";
import Img142 from "../assets/ceremonyPics/142.webp";
import Img143 from "../assets/ceremonyPics/143.webp";
import Img144 from "../assets/ceremonyPics/144.webp";
import Img145 from "../assets/ceremonyPics/145.webp";
import Img146 from "../assets/ceremonyPics/146.webp";
import Img147 from "../assets/ceremonyPics/147.webp";
import Img148 from "../assets/ceremonyPics/148.webp";
import Img149 from "../assets/ceremonyPics/149.webp";
import Img150 from "../assets/ceremonyPics/150.webp";
import Video2018 from "../assets/Videos/2018.mp4";
import HarmonyImage from "../assets/Images/Harmony-image.png";
import "./RecognitionCeremonyReviewPage.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const RecognitionCeremonyReviewPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title">
          <h1 className="banner-main-title">{t("recognition_ceremony_page_header")}</h1>
          <p className="banner-subtitle">{t("recognition_ceremony_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_recognition_ceremony_page_link1")}</Link>
        <span>{t("breadcrumbs_recognition_ceremony_page_span")}</span>
        <Link>{t("breadcrumbs_recognition_ceremony_page_link2")}</Link>
      </Breadcrumbs>
      <main className="recognition-ceremony-main-container">
        <div className="year-links">

          <Link to="/recognitionceremonyreview2019">{t("recognition_ceremony_page_text3")}</Link>
          <Link to="/recognitionceremonyreview">{t("recognition_ceremony_page_text2")}</Link>
        </div>
        <div className="harmony-text-image-section">
          <p>{t("recognition_ceremony_page_text1")}</p>
          <img src={HarmonyImage} alt="" />
        </div>
        <div className="video-section">
          <video controls src={Video2018}></video>
        </div>
        <div className="grid-images-section">
          <img src={Img1} alt="" />
          <img src={Img2} alt="" />
          <img src={Img3} alt="" />
          <img src={Img4} alt="" />
          <img src={Img5} alt="" />
          <img src={Img6} alt="" />
          <img src={Img7} alt="" />
          <img src={Img8} alt="" />
          <img src={Img9} alt="" />
          <img src={Img10} alt="" />
          <img src={Img11} alt="" />
          <img src={Img12} alt="" />
          <img src={Img13} alt="" />
          <img src={Img14} alt="" />
          <img src={Img15} alt="" />
          <img src={Img16} alt="" />
          <img src={Img17} alt="" />
          <img src={Img18} alt="" />
          <img src={Img19} alt="" />
          <img src={Img20} alt="" />
          <img src={Img21} alt="" />
          <img src={Img22} alt="" />
          <img src={Img23} alt="" />
          <img src={Img24} alt="" />
          <img src={Img25} alt="" />
          <img src={Img26} alt="" />
          <img src={Img27} alt="" />
          <img src={Img28} alt="" />
          <img src={Img29} alt="" />
          <img src={Img30} alt="" />
          <img src={Img31} alt="" />
          <img src={Img32} alt="" />
          <img src={Img33} alt="" />
          <img src={Img34} alt="" />
          <img src={Img35} alt="" />
          <img src={Img36} alt="" />
          <img src={Img37} alt="" />
          <img src={Img38} alt="" />
          <img src={Img39} alt="" />
          <img src={Img40} alt="" />
          <img src={Img41} alt="" />
          <img src={Img42} alt="" />
          <img src={Img43} alt="" />
          <img src={Img44} alt="" />
          <img src={Img45} alt="" />
          <img src={Img46} alt="" />
          <img src={Img47} alt="" />
          <img src={Img48} alt="" />
          <img src={Img49} alt="" />
          <img src={Img50} alt="" />
          <img src={Img51} alt="" />
          <img src={Img52} alt="" />
          <img src={Img53} alt="" />
          <img src={Img54} alt="" />
          <img src={Img55} alt="" />
          <img src={Img56} alt="" />
          <img src={Img57} alt="" />
          <img src={Img58} alt="" />
          <img src={Img59} alt="" />
          <img src={Img60} alt="" />
          <img src={Img61} alt="" />
          <img src={Img62} alt="" />
          <img src={Img63} alt="" />
          <img src={Img64} alt="" />
          <img src={Img65} alt="" />
          <img src={Img66} alt="" />
          <img src={Img67} alt="" />
          <img src={Img68} alt="" />
          <img src={Img69} alt="" />
          <img src={Img70} alt="" />
          <img src={Img71} alt="" />
          <img src={Img72} alt="" />
          <img src={Img73} alt="" />
          <img src={Img74} alt="" />
          <img src={Img75} alt="" />
          <img src={Img76} alt="" />
          <img src={Img77} alt="" />
          <img src={Img78} alt="" />
          <img src={Img79} alt="" />
          <img src={Img80} alt="" />
          <img src={Img81} alt="" />
          <img src={Img82} alt="" />
          <img src={Img83} alt="" />
          <img src={Img84} alt="" />
          <img src={Img85} alt="" />
          <img src={Img86} alt="" />
          <img src={Img87} alt="" />
          <img src={Img88} alt="" />
          <img src={Img89} alt="" />
          <img src={Img90} alt="" />
          <img src={Img91} alt="" />
          <img src={Img92} alt="" />
          <img src={Img93} alt="" />
          <img src={Img94} alt="" />
          <img src={Img95} alt="" />
          <img src={Img96} alt="" />
          <img src={Img97} alt="" />
          <img src={Img98} alt="" />
          <img src={Img99} alt="" />
          <img src={Img100} alt="" />
          <img src={Img101} alt="" />
          <img src={Img102} alt="" />
          <img src={Img103} alt="" />
          <img src={Img104} alt="" />
          <img src={Img105} alt="" />
          <img src={Img106} alt="" />
          <img src={Img107} alt="" />
          <img src={Img108} alt="" />
          <img src={Img109} alt="" />
          <img src={Img110} alt="" />
          <img src={Img111} alt="" />
          <img src={Img112} alt="" />
          <img src={Img113} alt="" />
          <img src={Img114} alt="" />
          <img src={Img115} alt="" />
          <img src={Img116} alt="" />
          <img src={Img117} alt="" />
          <img src={Img118} alt="" />
          <img src={Img119} alt="" />
          <img src={Img120} alt="" />
          <img src={Img121} alt="" />
          <img src={Img122} alt="" />
          <img src={Img123} alt="" />
          <img src={Img124} alt="" />
          <img src={Img125} alt="" />
          <img src={Img126} alt="" />
          <img src={Img127} alt="" />
          <img src={Img128} alt="" />
          <img src={Img129} alt="" />
          <img src={Img130} alt="" />
          <img src={Img131} alt="" />
          <img src={Img132} alt="" />
          <img src={Img133} alt="" />
          <img src={Img134} alt="" />
          <img src={Img135} alt="" />
          <img src={Img136} alt="" />
          <img src={Img137} alt="" />
          <img src={Img138} alt="" />
          <img src={Img139} alt="" />
          <img src={Img140} alt="" />
          <img src={Img141} alt="" />
          <img src={Img142} alt="" />
          <img src={Img143} alt="" />
          <img src={Img144} alt="" />
          <img src={Img145} alt="" />
          <img src={Img146} alt="" />
          <img src={Img147} alt="" />
          <img src={Img148} alt="" />
          <img src={Img149} alt="" />
          <img src={Img150} alt="" />
        </div>
      </main>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" />
      </div>

      <Footer />
    </>
  );
};

export default RecognitionCeremonyReviewPage;
